import { HubTileID } from '@office-start/appbar-types';
export function isCopilotExtensibilityEnabled(appId, featureGates) {
    var _a;
    // Enable only for copilot app
    return appId === HubTileID.copilotMos
        ? Boolean((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.copilotGates) === null || _a === void 0 ? void 0 : _a.copilotExtensibilityEnabled)
        : false;
}
//# sourceMappingURL=isCopilotExtensibilityEnabled.js.map